module.exports = __webpack_public_path__ + "img/yacht-4.758059fb.jpg";